import { z } from "zod";
import { AuditActionSchema } from "./enums.js";

export const HealthResponseSchema = z.object({
  status: z.literal("ok"),
  service: z.literal("ow-recruitment"),
  version: z.string(),
});
export type HealthResponse = z.infer<typeof HealthResponseSchema>;

export const ErrorResponseSchema = z.object({
  error: z.object({
    code: z.string(),
    message: z.string(),
  }),
});
export type ErrorResponse = z.infer<typeof ErrorResponseSchema>;

/** An audit-trail row (PRD §7.4). */
export const AuditEntrySchema = z.object({
  id: z.uuid(),
  entityType: z.string(),
  entityId: z.uuid(),
  action: AuditActionSchema,
  changedBy: z.string().nullable(),
  diff: z.unknown().nullable(),
  createdAt: z.string(),
});
export type AuditEntry = z.infer<typeof AuditEntrySchema>;
